import React, { useContext } from "react"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog"
import { useNavigate } from "react-router-dom"
import { Button } from "../ui/button"

interface Props {
  isOpen: boolean
  onClose: () => void
}

const SessionTimeOutModal: React.FC<Props> = ({ isOpen, onClose }) => {
  const navigate = useNavigate()

  const handleClose = () => {
    onClose()
    navigate("/")
  }

  const handleSignIn = () => {
    onClose()
    navigate("/sign-in")
  }

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && handleClose()}>
      <DialogContent className="max-w-lg max-h-screen overflow-y-auto relative p-6">
        <button
          onClick={handleClose}
          aria-label="Close"
          className="absolute right-4 top-4 text-gray-400 hover:text-black text-xl"
        >
          ✕
        </button>
        <DialogHeader>
          <DialogTitle className="text-center mb-4 text-2xl">
            You're Logged Out
          </DialogTitle>
          <DialogDescription className="text-center text-lg mb-6">
            To help keep your account secure, we’ve logged you out after a
            period of inactivity. Just sign in again to pick up where you left
            off.{" "}
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-center">
          <Button onClick={handleSignIn}>Sign In</Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default SessionTimeOutModal
